// extracted by mini-css-extract-plugin
export default {"sectionList":"n9Y9a-djg3SqDJI5fDFpt","heading":"_3y3pDoCIhI9URdFG61lW0N"};